module.exports = __webpack_public_path__ + "img/Inflammation-LICA_GSE146409.423fc2b7.png";